import { IProduct } from "~/integrations/firebase/collections";
import { SearchProductWithScore } from "./types";

export const mapIProductToSearchProduct = (
  product: IProduct,
): SearchProductWithScore => ({
  id: product.id,
  isbn: product.isbn,
  title: product.title ?? "",
  author: product.author ?? [],
  publisher: product.publisher ?? "",
  publishers: product.publishers,
  imprints: product.imprints,
  publishedAt: product.publishedAt
    ? new Date(product.publishedAt.seconds * 1000)
    : null,
  productGroupDescription: product.productGroupDescription ?? "",
  nonExistent: product.nonExistent,
  score: 0,
});
